module.exports = __webpack_public_path__ + "files/3d3a53586bd78d1069ae4b89a3b9aa98.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Roboto-regular.svg
 ** module id = 870
 ** module chunks = 0
 **/